import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import LessonProgressBar from './LessonProgressBar';
import { PrmCurriculumProgressReportResult } from 'types/schema-generated-types';
import { sortCurriculum } from './lesson-progress-chart-util';

type Props = {
  prmCurriculumProgressReport?: PrmCurriculumProgressReportResult;
};

const LessonProgressChart: React.FC<Props> = ({ prmCurriculumProgressReport }) => {
  const classes = useStyles();
  return (
    <Box className={classes.base}>
      {sortCurriculum(prmCurriculumProgressReport?.curriculums).map((x, index) => (
        <LessonProgressBar
          key={index}
          title={`${x.productCurriculum?.name!} Lesson Progress`}
          completed={x.averageLessonCompletedCount}
          assigned={x.averageLessonAssignedCount}
          total={x.totalLessonCount}
        />
      ))}
    </Box>
  );
};
const useStyles = makeStyles(() => ({
  base: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: 16
  }
}));
export default LessonProgressChart;
